export default {
  getToken: () => {
    const data = localStorage.getItem("info");
    const token = JSON.parse(data !== null ? data : "{}").token;
    return token;
  },
  getEmail: () => {
    const data = localStorage.getItem("info");
    const email = JSON.parse(data !== null ? data : "{}").user.email;
    return email;
  },
  getPrivileges: () => {
    const data = localStorage.getItem("info");
    const privileges = JSON.parse(data !== null ? data : "{}").user.privileges;
    return privileges;
  }
};
